module.exports = __webpack_public_path__ + "static/media/Illustration2.4ecc07ca.png";